<template>
  <div class="dynamic-item">
    <div class="tip">
      <span class="weight" v-if="dataItem && dataItem.isMust">*</span>
      <span class="text">{{ dataItem?.tip ?? "" }}</span>
      <el-tooltip
        :content="getBeChangeTip"
        placement="top"
        v-if="dataItem && dataItem.beChange"
      >
        <i class="el-icon-warning" style="color: #ffbf04"></i>
      </el-tooltip>
    </div>
    <div class="value-wrap fill-wrap">
      <template v-if="componentType === IConst_Field.Input">
        <el-input
          maxlength="100"
          placeholder="请输入"
          :disabled="disabled"
          v-model="localValue"
        />
      </template>
      <template
        v-if="
          componentType === IConst_Field.Pull ||
          componentType === IConst_Field.MutilPull
        "
      >
        <el-select
          v-model="localValue"
          placeholder="请选择"
          :multiple="componentType === IConst_Field.MutilPull"
          :disabled="disabled"
        >
          <el-option
            v-for="item in dataItem.options ? dataItem.options : []"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <template v-if="componentType === IConst_Field.Area">
        <ArearSelect
          @change="handleChange"
          :disabled="disabled"
          v-model="localValue"
          :valueName.sync="dataItem.modeValueName"
        />
      </template>
    </div>
  </div>
</template>

<script>
/**
 * 录入方式（1-文本框，2-下拉框，3-地址选择器，4-复选框）
 */
import ArearSelect from "./arearSelect.vue";
import { IConst_Field } from "../util/ViewHelp";

export default {
  components: { ArearSelect },
  props: {
    type: {
      default: () => 1,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    value: {
      //modeValue
      type: [String, Array, null],
      default: () => "",
    },
    dataItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      IConst_Field: IConst_Field,
      localValue: "",
      areaInfo: {},
    };
  },
  computed: {
    componentType() {
      return this.type;
    },
    getBeChangeTip() {
      if (this.dataItem && this.dataItem.beChange) {
        const { inputType, changeContent, selectEnum } = this.dataItem;
        if (inputType === 4 || inputType === 2) {
          // 说明是多选 或者 下拉框
          try {
            const select = JSON.parse(selectEnum);
            const changeContentArr = changeContent
              .split(",")
              .filter((item) => item !== "无");
            if (changeContentArr.length === 0) {
              return `变更前：无`;
            }
            const changeContentArrStr = changeContentArr
              .map((item) => select[item])
              .join("、");
            return `变更前：${changeContentArrStr}`;
          } catch (error) {
            console.error("解析 selectEnum 时出错:", error);
            return `变更前：解析错误`;
          }
        } else {
          return `变更前：${this.dataItem.changeContent}`;
        }
      }
      return "";
    },
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        // console.log(newVal, "newVal");
        if (newVal && newVal !== oldVal) {
          if (this.type == 4) {
            // 多选：value 可能是逗号分隔的字符串，也可能已经是数组
            if (Array.isArray(newVal)) {
              this.localValue = newVal;
            } else {
              this.localValue = String(newVal)
                .split(",")
                .filter((item) => item !== "");
            }
          } else {
            this.localValue = newVal;
          }
        }
      },
      immediate: true,
    },
    localValue: {
      handler(newVal, oldVal) {
        this.$emit("input", newVal);
      },
      // immediate: true,
    },
  },
  methods: {
    handleChange(areaInfo) {
      /** areaInfo = {
       * provinceName: ,
        cityName: ,
        areaName: ,

        province: , //省份编码
        city: , //城市编码
        area: , //区域编码
      }
       */
    },
  },
};
</script>

<style scoped lang="scss">
.dynamic-item {
  width: 100%;
  display: flex;
  flex-direction: column;

  .tip {
    display: flex;
    align-items: center;

    .weight {
      width: 8px;
      height: 14px;
      font-size: 14px;
      font-weight: 400;
      color: #f6212d;
      line-height: 22px;
    }

    .text {
      font-size: 14px;
      font-weight: 600;
      color: #262626;
    }
  }

  .value-wrap {
    width: 100%;
    margin-top: 6px;

    ::v-deep .el-input__inner,
    ::v-deep .el-cascader {
      height: 32px;
      line-height: 32px;
    }

    ::v-deep .el-input__icon {
      line-height: 32px;
    }
  }

  .fill-wrap {
    & > * {
      width: 100%;
    }
    ::v-deep .el-cascader {
      width: 100%;
    }
  }
}
</style>
